<template>
  <div style="height:100vh;overflow: hidden;">
    <div v-if="showMask && fileType=='wps'" class="mask"></div>
    <iframe v-if="frameUrl" :src="frameUrl" id="player" width="100%" height="100%" frameborder="0" @load="onFrameLoaded"></iframe>
  </div>
</template>

<script>
import { getFilePrevew } from '@/api/manage'

export default {
    name: 'FileView',
    data(){
      return{
        url: '',
        frameUrl: '',
        fileType: '',
        showMask: false
      }
    },
    created(){
      if(this.$route.query.url){
        this.url = decodeURIComponent(atob(this.$route.query.url))
        // this.url = decodeURIComponent(this.$route.query.file)
      }else{
        alert('参数错误')
      }
    },
    mounted(){
      if(this.url.endsWith('ppt') || this.url.endsWith('pptx') || this.url.endsWith('doc') || this.url.endsWith('docx') || this.url.endsWith('xls') || this.url.endsWith('xlsx')){
        this.frameUrl = getFilePrevew(this.url)
        this.fileType = 'wps'
      }else{
        this.frameUrl = this.url
        this.fileType = 'other'
      }
      
    },
    methods:{
      getFilePrevew,
      onFrameLoaded(){
        if(this.frameUrl.includes('officeapps')){
          this.showMask = true
        }
      }
    }
}
</script>

<style scoped>
.mask{
  position: absolute;
  height: 20px;
  width: 100px;
  background: #444444;
  bottom: 2px;
  right: 0;
}
</style>